const CREATOR_ATTRIBUTION_TOKEN_ASIN_KEY = 'creativeASIN';
/**
 * Helper function to add ASIN to creator attribution token
 */
export const addAsinToCreatorAttributionToken = (creatorAttributionToken, asin) => {
    try {
        // Decode the base64 token to get URLSearchParams string
        const decryptedToken = atob(creatorAttributionToken);
        // Parse as URLSearchParams
        const params = new URLSearchParams(decryptedToken);
        // Set the ASIN parameter
        params.set(CREATOR_ATTRIBUTION_TOKEN_ASIN_KEY, asin);
        // Convert back to string and encode as base64
        const creatorAttributionTokenString = params.toString();
        return btoa(creatorAttributionTokenString);
    }
    catch (_error) {
        return creatorAttributionToken; // Return original token on error
    }
};
/**
 * Helper function to get ASIN from creator attribution token
 */
export const getAsinFromCreatorAttributionToken = (creatorAttributionToken) => {
    try {
        // Decode the base64 token to get URLSearchParams string
        const decryptedToken = atob(creatorAttributionToken);
        const params = new URLSearchParams(decryptedToken);
        // Get the ASIN parameter
        return params.get(CREATOR_ATTRIBUTION_TOKEN_ASIN_KEY);
    }
    catch (_error) {
        return '';
    }
};
